/**
 * 年级列表
 * @type {({name: string, id: number}|{name: string, id: number}|{name: string, id: number}|{name: string, id: number}|{name: string, id: number})[]}
 */
export const gradeList = [
  {
    id: 1,
    name: '一年级',
    gradeSet: 'gradeOne'
  },
  {
    id: 2,
    name: '二年级',
    gradeSet: 'gradeTwo'
  },
  {
    id: 3,
    name: '三年级',
    gradeSet: 'gradeThree'
  },
  {
    id: 4,
    name: '四年级',
    gradeSet: 'gradeFour'
  },
  {
    id: 5,
    name: '五年级',
    gradeSet: 'gradeFive'
  },
  {
    id: 6,
    name: '六年级',
    gradeSet: 'gradeSix'
  },
  {
    id: 7,
    name: '初一',
    gradeSet: 'gradeSeven'
  },
  {
    id: 8,
    name: '初二',
    gradeSet: 'gradeEight'
  },
  {
    id: 9,
    name: '初三',
    gradeSet: 'gradeNine'
  },
  {
    id: 10,
    name: '高一',
    gradeSet: 'gradeTen'
  },
  {
    id: 11,
    name: '高二',
    gradeSet: 'gradeEleven'
  },
  {
    id: 12,
    name: '高三',
    gradeSet: 'gradeTwelve'
  }
]
/**
 * 是否授权
 * @type {{NO: number, YES: number}}
 */
export const isAuth = {
  YES: 1, // 是
  NO: 0 // 否
}
/**
 * 是否关注
 * @type {{NO: number, YES: number}}
 */
export const isFollow = {
  YES: 1, // 是
  NO: 0 // 否
}
/**
 *  是否关联公众号
 * @type {{NO: number, YES: number}}
 */
export const isRelation = {
  YES: 1, // 是
  NO: 0 // 否
}
/**
 *  是否绑定
 * @type {{NO: number, YES: number}}
 */
export const isBind = {
  YES: 1, // 是
  NO: 0 // 否
}
/**
 * 消息模板类型
 * @type {{SMS: number, WE_CHAT: number}}
 */
export const messageType = {
  WE_CHAT: 1, // 微信
  SMS: 0 // 短信
}
/**
 * 审核类型
 * @type {{TO_BE_REVIEWED: number, ADOPT: number, NO_PASS: number}}
 */
export const auditType = {
  TO_BE_REVIEWED: 0, // 待审核
  ADOPT: 1, // 通过
  NO_PASS: 2 // 不通过
}
/**
 * 审核类型
 * @type {{SHOW: number, BLANK: number}}
 */
export const miniApp = {
  SHOW: 0, // 显示
  BLANK: 1 // 不显示
}
/**
 *
 * 归档类型
 * @type {{NO: number, YES: number}}
 */
export const isFiled = {
  YES: 1, // 已归档
  NO: 0 // 未归档
}
/**
 * 是否班级社团教师
 * @type {{NO: number, YES: number}}
 */
export const isClubClassTeacher = {
  YES: 1, // 是
  NO: 0 // 否
}
/**
 * 归档类型
 * @type {{NO: number, YES: number}}
 */
export const filedType = {
  NO: 0, // 否
  YES: 1// 是
}
/**
 * 文件上传类型
 * @type {{img: number, video: number,rest number }}
 */
export const fileType = {
  img: 1, // 图片
  video: 2, // 视频
  rest: 3, // 其他
  big: 104857600 // 大小kB=1024*1024*100
}
/**
 * 模版类型
 * @type {{SHORT_MESSAGE: number, WE_CHAT: number}}
 */
export const templateType = {
  SHORT_MESSAGE: 0, // 短信
  WE_CHAT: 1 // 微信
}
/**
 * 是否使用
 * @type {{NO: number, YES: number}}
 */
export const isUse = {
  YES: 1, // 使用
  NO: 0 // 不使用
}
/**
 * 请假状态
 * @type {{NORMAL: number, TRUANT: number,LATE: number, LEAVE: number}}
 */
export const rollCallStatus = {
  NORMAL: 0, // 正常
  TRUANT: 1, // 旷课
  LATE: 2, // 迟到
  LEAVE: 3 // 请假
}
/**
 * 评分制类型
 * @type {{AVERAGE: number, TOTAL_POINTS: number}}
 */
export const statistics = {
  AVERAGE: 0, // 平均分制
  TOTAL_POINTS: 1 // 总分制
}
/**
 * 评价类型
 * @type {{NULL: number, FLAG: number, STAR: number}}
 */
export const evaluate = {
  NULL: 0, // 无
  FLAG: 1, // 流动红旗
  STAR: 2, // 星级
  victorClass: 3 // 优胜
}

/**
 * 评价类型
 * @type {{MINUS: number, ADD: number}}
 */
export const itemType = {
  MINUS: 0, // 减
  ADD: 1 // 加
}
/**
 * 评价类型
 * @type {{MINUS: number, ADD: number}}
 */
export const offlineScoreType = {
  MINUS: 0, // 扣分
  ADD: 1 // 加分
}
/**
 * 上架状态
 * @type {{ON: number, OFF: number, END: number}}
 */
export const listingStatus = {
  ON: 0, // 进行中
  OFF: 1, // 未开始
  END: 2 // 已结束
}
/**
 * 是否需要备注
 * @type {{NO: number, YES: number}}
 */
export const setNote = {
  NO: 0, // 不需要
  YES: 1 // 需要
}
/**
 * 是否需要图片
 * @type {{NO: number, YES: number}}
 */
export const setPicture = {
  NO: 0, // 不需要
  YES: 1 // 需要
}
/**
 * 是否需要视频
 * @type {{NO: number, YES: number}}
 */
export const setVideo = {
  NO: 0, // 不需要
  YES: 1 // 需要
}
/**
 * 学生还是老师
 * @type {{STUDENT: number, TEACHER: number}}
 */
export const isStudent = {
  STUDENT: 0, // 学生
  TEACHER: 1 // 老师
}
/**
 * 男生还是女生
 * @type {{MAN: number, WOMAN: number}}
 */
export const sexual = {
  MAN: 0, // 男生
  WOMAN: 1 // 女生
}

/**
 *  学生状态
 * @type {{normal: number, transfer: number, suspension: number}}
 */
export const studentSate = {
  normal: 0, // 正常
  suspension: 2, // 休学
  transfer: 1, // 转学
  activeChangeClass: 3, // 主动转班
  passiveChangeClass: 4, // 被动转班
  noTest: 5, // 该生不参加考试
  filed: 6 // 归档
}
/**
 * 在职状态
 * @type {{INCUMBENCY: number, QUIT: number, RETIRE: number}}
 */
export const jobState = {
  INCUMBENCY: 0, // 在职
  QUIT: 1, // 离职
  RETIRE: 2 // 退休
}
/**
 * 是否已经选择
 * @type {{isSelected: number, noSelected: number}}
 */
export const selected = {
  isSelected: 1,
  noSelected: 0
}
/**
 * 学期类型
 * @type {{SECOND: number, FIRST: number}}
 */
export const termType = {
  FIRST: 0, // 上学期
  SECOND: 1 // 下学期
}
/**
 * 当前学期类型
 * @type {{NO: number, YES: number}}
 */
export const termCurrentType = {
  NO: 0, // 否
  YES: 1 // 是
}
/**
 * 学期只读类型
 * @type {{NO: number, YES: number}}
 */
export const termReadOnlyMark = {
  NO: 0, // 否
  YES: 1// 是
}

/**
 * 审核状态
 * @type {{WAIT: number, YES: number, NO: number}}
 */
export const appeal = {
  WAIT: 0, // 等待审核
  YES: 1, // 通过
  NO: 2 // 驳回
}
/**
 * 是否主科
 * @type {{isMain: number, noMain: number}}
 */
export const isMain = {
  isMain: 1,
  noMain: 0
}

/**
 * 六好少年奖章关联模块
 */
export const medalDecisionModule = {
  classEvaluate: 1, // 班级评价
  studentEvaluate: 2, // 学生评价
  examModule: 3, // 成绩模块
  activityModule: 4, // 活动模块
  examination: 5 // 学生体检
}

/**
 * 六好少年奖章判定时间
 */
export const medalDecisionTime = {
  thisAllYear: 1, // 本学年一整年
  thisLastYear: 2, // 本学年上半年
  thisNextYear: 3, // 本学年下半年
  lastAllYear: 4, // 上学年一整年
  lastLastYear: 5, // 上学年上半年
  lastNextYear: 6 // 上学年下半年
}

/**
 * 六好少年班级评价规则事件
 */
export const medalEvent = {
  record: 2, // 记录
  addRecord: 1, // 加分记录
  cutRecord: 0, // 扣分记录
  recordNum: 4, // 记录分数
  recordLevel: 5, // 记录等级
  recordYear: 6 // 记录学期
}

/**
 * 六好少年班级评价事件条件
 */
export const medalEventRequire = {
  same: 1, // 等于
  big: 2, // 大于
  bigSame: 3, // 大于等于
  small: 4, // 小于
  smallSame: 5 // 小于等于
}

/**
 * 六好少年班级评价事件参数
 */
export const requirementNum = {
  Integer: 1, // 正整数
  allowNoInteger: 2 // 允许非正整数
}

/**
 * 六好少年规则输出结果
 */
export const putResult = {
  yes: 1, // 达标
  no: 0 // 不达标
}

/**
 * 六美少年奖章获取方式
 */
export const medalGetWay = {
  default: 0, // 默认获取
  onSystem: 1 // 系统规则判定
}

/**
 * 是否只评价所授课学生
 * @type {{NO: number, YES: number}}
 */
export const onlyTeachStudent = {
  YES: 1, // 是
  NO: 0 // 否
}

export const inspectorList = [
  {
    id: 1,
    name: '老师'
  }, {
    id: 0,
    name: '学生'
  }]

/**
 * 评价类型是否微信通知
 * @type {{NO: number, YES: number}}
 */
export const isWeChatNotify = {
  YES: 1, // 是
  NO: 0 // 否
}

/**
 * 考试类型
 */
export const examType = [
  {
    id: 0,
    name: '单元考'
  }, {
    id: 1,
    name: '期中考'
  }, {
    id: 2,
    name: '期末考'
  }]
/**
 * 社团规则类型
 * @type {{ONE: number, MUCH: number}}
 */
export const clubRule = {
  ONE: 0, // 一对一
  MUCH: 1 // 一对多
}
/**
 * 教师类型
 * @type {{in: number, out: number}}
 */
export const teacherType = {
  in: 0, // 否
  out: 1 // 是
}
/**
 * 社团等级
 * @type {{schoolLevel: number, noSchoolLevel: number}}
 */
export const clubLevel = {
  schoolLevel: 1, // 校级
  gradeLevel: 0 // 非校级
}
/**
 * 点名状态
 * @type {{normal: number, leave: number}}
 */
export const rollStatus = {
  normal: 0, // 正常
  leave: 1, // 请假
  late: 2, // 迟到
  cut: 3, // 旷课
  early: 4 // 早退
}

/**
 * 是否关联学生
 * @type {{yes: number, no: number}}
 */
export const relation = {
  yes: 1, // 是
  no: 0 // 否
}

/**
 * 班主任绑定微信状态
 * @type {{yes: number, no: number}}
 */
export const weChatBindStatus = {
  yes: 1, // 是
  no: 0 // 否
}

/**
 * 申诉管理员通知
 */
export const isAppealMessage = {
  yes: 1, // 是
  no: 0 // 否
}

/**
 * 班级评价类型是否默认流程
 */
export const defaultThread = {
  yes: 1, // 默认流程
  onConfig: 0 // 按任务表
}

/**
 * 点赞还是曝光
 */
export const exposureType = {
  exposure: 1, // 曝光
  fabulous: 0 // 点赞
}
/**
 * 点赞还是曝光
 */
export const auditStatus = {
  examine: 0, // 审核中
  passed: 1, // 已通过
  fail: 2 // 已通过
}

/**
 * 是否置顶
 * 用于排序，因为和多个字段一起排序 所以只能0表示是1表示否
 */
export const isTop = {
  YES: 0, // 是
  NO: 1 // 否
}

/**
 * 是否允许分享
 */
export const isShare = {
  YES: 1, // 是
  NO: 0 // 否
}

/**
 * 是否允许撤销
 */
export const rollBack = {
  YES: 1, // 是
  NO: 0 // 否
}
/**
 * 是否允许大屏端显示其他班级
 */
export const isOtherClass = {
  YES: 1, // 是
  NO: 0 // 否
}

/**
 * 教师自评状态
 */
export const teacherStatus = {
  YES: 1, // 是
  NO: 0 // 否
}

/**
   * 教师考核范围
   */
export const assessScope = {
  HEADTEACHER: 1, // 是
  TEACHER: 0 // 否
}

/**
 * 教师考核状态
 */
export const assessStatus = {
  Filed: 1, // 已经归档
  assess: 0, // 考核中
  allAssess: 2 // 考核中
}

/**
 * 是否班主任
 */
export const isHeadTeacher = {
  YES: 1, // 是
  NO: 0 // 否
}

/**
 * 打印机类型
 */
export const printerType = {
  BLACK: 0, // 黑盒打印
  COL: 1 // 彩色打印
}

/**
 * 打印机状态
 */
export const printerStatus = {
  REPAIR: 0, // 维修中
  WORK: 1, // 工作中
  IDLE: 2 // 空闲中
}

/**
 * 班级评价类型是否默认流程
 */
export const evaluateType = {
  student: 0,
  class: 1
}
/**
 * 德育大屏是否字段
 */
export const moralismScreen = {
  YES: 1,
  NO: 0
}
